module.exports = "<ul class=\"dropdown-menu\" aria-labelledby=\"{{ctxDropdown.dropdownId}}\" ng-style=\"{'top': $ctrl.showPopup ? 'auto' : '100%', 'bottom': $ctrl.showPopup ? '100%' : 'auto'}\">\n    <ctx-dropdown-list-item ng-repeat=\"item in ctxDropdownListCtrl.list\" item=\"item\"></ctx-dropdown-list-item>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/ctxDropdown/ctxDropdownList.template.html
// module id = 154
// module chunks = 0 1